import { render, staticRenderFns } from "./TomeServicer.vue?vue&type=template&id=3529c357&"
import script from "./TomeServicer.vue?vue&type=script&lang=ts&"
export * from "./TomeServicer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports